import loadable from '@loadable/component';

export const loadLocaleData = {
  da: loadable(() =>
    import(/* webpackChunkName: "locale-da" */ 'react-intl/locale-data/da')
  ),
  de: loadable(() =>
    import(/* webpackChunkName: "locale-de" */ 'react-intl/locale-data/de')
  ),
  en: loadable(() =>
    import(/* webpackChunkName: "locale-en" */ 'react-intl/locale-data/en')
  ),
  es: loadable(() =>
    import(/* webpackChunkName: "locale-es" */ 'react-intl/locale-data/es')
  ),
  et: loadable(() =>
    import(/* webpackChunkName: "locale-et" */ 'react-intl/locale-data/et')
  ),
  fi: loadable(() =>
    import(/* webpackChunkName: "locale-fi" */ 'react-intl/locale-data/fi')
  ),
  fr: loadable(() =>
    import(/* webpackChunkName: "locale-fr" */ 'react-intl/locale-data/fr')
  ),
  it: loadable(() =>
    import(/* webpackChunkName: "locale-it" */ 'react-intl/locale-data/it')
  ),
  nl: loadable(() =>
    import(/* webpackChunkName: "locale-nl" */ 'react-intl/locale-data/nl')
  ),
  no: loadable(() =>
    import(/* webpackChunkName: "locale-no" */ 'react-intl/locale-data/no')
  ),
  pt: loadable(() =>
    import(/* webpackChunkName: "locale-pt" */ 'react-intl/locale-data/pt')
  ),
  ru: loadable(() =>
    import(/* webpackChunkName: "locale-ru" */ 'react-intl/locale-data/ru')
  ),
  sv: loadable(() =>
    import(/* webpackChunkName: "locale-sv" */ 'react-intl/locale-data/sv')
  ),
};

export const loadMessages = {
  da: loadable(() =>
    import(/* webpackChunkName: "messages-da" */ './messages/da.json')
  ),
  de: loadable(() =>
    import(/* webpackChunkName: "messages-de" */ './messages/de.json')
  ),
  en: loadable(() =>
    import(/* webpackChunkName: "messages-en" */ './messages/en.json')
  ),
  es: loadable(() =>
    import(/* webpackChunkName: "messages-es" */ './messages/es.json')
  ),
  et: loadable(() =>
    import(/* webpackChunkName: "messages-et" */ './messages/et.json')
  ),
  fi: loadable(() =>
    import(/* webpackChunkName: "messages-fi" */ './messages/fi.json')
  ),
  fr: loadable(() =>
    import(/* webpackChunkName: "messages-fr" */ './messages/fr.json')
  ),
  it: loadable(() =>
    import(/* webpackChunkName: "messages-it" */ './messages/it.json')
  ),
  nl: loadable(() =>
    import(/* webpackChunkName: "messages-nl" */ './messages/nl.json')
  ),
  no: loadable(() =>
    import(/* webpackChunkName: "messages-no" */ './messages/no.json')
  ),
  pt: loadable(() =>
    import(/* webpackChunkName: "messages-pt" */ './messages/pt.json')
  ),
  ru: loadable(() =>
    import(/* webpackChunkName: "messages-ru" */ './messages/ru.json')
  ),
  sv: loadable(() =>
    import(/* webpackChunkName: "messages-sv" */ './messages/sv.json')
  ),
};

export const loadStaticMessages = {
  da: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-da" */ './static-messages/da-countries.json'
    )
  ),
  de: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-de" */ './static-messages/de-countries.json'
    )
  ),
  en: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-en" */ './static-messages/en-countries.json'
    )
  ),
  es: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-es" */ './static-messages/es-countries.json'
    )
  ),
  et: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-et" */ './static-messages/et-countries.json'
    )
  ),
  fi: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-fi" */ './static-messages/fi-countries.json'
    )
  ),
  fr: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-fr" */ './static-messages/fr-countries.json'
    )
  ),
  it: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-it" */ './static-messages/it-countries.json'
    )
  ),
  nl: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-nl" */ './static-messages/nl-countries.json'
    )
  ),
  no: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-no" */ './static-messages/no-countries.json'
    )
  ),
  pt: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-pt" */ './static-messages/pt-countries.json'
    )
  ),
  ru: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-ru" */ './static-messages/ru-countries.json'
    )
  ),
  sv: loadable(() =>
    import(
      /* webpackChunkName: "static-messages-sv" */ './static-messages/sv-countries.json'
    )
  ),
};

export const loadLocaleDataDynamically = async (locale) => {
  return loadLocaleData[locale].load();
};

export const loadMessagesDynamically = async (locale) => {
  const messages = await loadMessages[locale].load();
  return messages.default || messages;
};

export const loadStaticMessagesDynamically = async (locale) => {
  const staticMessages = await loadStaticMessages[locale].load();
  return staticMessages.default || staticMessages;
};
